import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Order} from '../interfaces/order';
import {AuthService} from '../services/auth.service';
import {MockMenuService} from '../services/mock-menu.service';
import * as Query from '../global-query';
import {OrderState} from './OrderState';
import {UserService} from '../services/user.service';
import {MenuItemsService} from '../services/menu-items.service';
import {Utility} from '../utility';
import {MenuItem} from '../interfaces/menu-item';
import {AppsyncService} from './appsync.service';
import {Apollo} from 'apollo-angular';
import {v4 as uuid} from 'uuid';
import {LoaderService} from '../pages/loader/loader.service';
import {ItonicsAuthService} from './itonicsAuth.service';
import * as moment from 'moment-timezone';
import { Subscription } from 'rxjs';
import { SettingService } from './setting.service';
import { Settings } from '../interfaces/setting';

@Injectable()
export class OrderService extends MockMenuService {
  public orderItem: any = {};

  public items: any[] = [];

  settingSubscrition: Subscription;
  public settingsData: any = [];
  public mode: string;

  public loggedId: string;

  private orderSubject: Subject<OrderState> = new BehaviorSubject<OrderState>(<OrderState>{
    loaded: true,
    items: this.items
  });

  orderState = this.orderSubject.asObservable();

  constructor(
    private _auth: AuthService,
    private _mothMenuService: MockMenuService,
    private _userService: UserService,
    private menuService: MenuItemsService,
    public appsync: AppsyncService,
    public apollo: Apollo,
    public itonicsAuthService: ItonicsAuthService,
    public loaderService: LoaderService,
    private settingService: SettingService,
  ) {
    super(apollo, appsync, itonicsAuthService, loaderService);

    this.loggedId = itonicsAuthService.getCurrentUser()['username'];

    let settingdata;
    this.settingSubscrition = this.settingService.settings.subscribe((settings: Settings) => {
      settingdata = settings;
      if (settingdata.length == 0) {
        // console.log('no data')
        return
      }
      settingdata.forEach(element => {
        this.settingsData[element.alias] = element.value;
      });

    this.getUserOrdersByDate(this.loggedId, Utility.getTodayDate()).subscribe((todayOrder) => {
      Object.keys(todayOrder).forEach((key) => {
        const todayOrderData = todayOrder[key];

        this.items.push({
          id: todayOrderData.id,
          menuItemId: todayOrderData.menuItem.id,
          title: todayOrderData.menuItem.title,
          price: todayOrderData.menuItem.price,
          quantity: todayOrderData.quantity,
          userId: todayOrderData.userId,
          note: '',
          date: todayOrderData.date,
          discountPrice: Math.round(
            todayOrderData.menuItem.price * todayOrderData.quantity - todayOrderData.menuItem.price * todayOrderData.quantity * 0.87 * (this.settingsData.discount / 100)
          )
        });
      });

      this.orderSubject.next(<OrderState>{loaded: true, items: this.items});
    });

    })
  }

  editOrderValue(orderItem: any) {
    return Observable.create((observer) => {
      this.editOrder(orderItem, this.loggedId, Query.editOrderItem).subscribe(
        (order) => {
          observer.next(order);
          this.onEnd();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }

  addOrderValue(orderItem: any) {
    /*  if (orderItem.id) {

          // Update Case
          return Observable.create(observer => {
              this.editOrder(orderItem, this.loggedId, Query.editOrderItem).subscribe(order => {
                  observer.next(order);
                  observer.complete();
              }, err => {
                  observer.error(err);
              });
          });

      } else {*/

    // Add Case
    return Observable.create((observer) => {
      this.addOrder(orderItem, Query.addOrder).subscribe(
        (order) => {
          observer.next(order);
          this.onEnd();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });

    //}
  }

  getOrdersByUserId(userId: string): Observable<Array<Order>> {
    return Observable.create((observer) => {
      this.getUserOrder(userId, Query.userOrder).subscribe((userOrders) => {
        observer.next(userOrders['data']['userOrder']);
        observer.complete();
      });
    });
  }

  getOrdersByDate(date: number): Observable<Array<Order>> {
    return Observable.create((observer) => {
      this.getOrderByDate(date, Query.orderByDate).subscribe((userOrders) => {
        observer.next(userOrders);
        observer.complete();
      });
    });
  }

  getUserOrdersByDate(userId: string, date: any): Observable<Array<Order>> {
    return Observable.create((observer) => {
      this.getUserOrderListByDate(userId, date, Query.userDateOrder).subscribe((userOrders) => {
        const result: any = userOrders['data'];
        observer.next(result['userTodayOrder']);
        observer.complete();
      });
    });
  }

  getOrderInfobyId(id: any): Observable<Order> {
    return Observable.create((observer) => {
      this.getOrderById(id, Query.getOrder).subscribe((res) => {
        const result: any = res['data'];
        observer.next(result.getOrder);
        observer.complete();
      });
    });

    /*  return Observable.create(observer => {
          this.getOrderById(id, Query.getOrder).subscribe(order => {

              console.log(order);

              observer.next(order);
              observer.complete();
          });
      });*/
  }

  /* editOrder(name, quantity) {

   }*/

  deleteOrder(name, quantity) {
  }

  listUserOrder(name, quantity) {
  }

  addQuickOrder(_item: MenuItem) {
    this.arrangeOrder(_item, false);
  }

  saveOrder(_orderItem: any) {
    const oldItem = this.items.find((h) => h.menuItemId === _orderItem.menuItemId);
    // if (oldItem) {
    if (!_orderItem.isNew) {
      // Update the order

      const oldItem = this.items.find((h) => h.menuItemId === _orderItem.menuItemId);
      if (oldItem) {
        const index = this.items.indexOf(oldItem);

        if (_orderItem.orderType == 2) {
          this.items[index].quantity = _orderItem.quantity;
        } else {
          this.items[index].quantity = this.items[index]['quantity'] + parseInt(_orderItem.quantity);
        }
        this.items[index].discountPrice = Math.round(
          this.items[index].price * this.items[index].quantity - this.items[index].price * this.items[index].quantity * 0.87 * (this.settingsData.discount / 100)
        );
        this.items[index].note = _orderItem.note;
        this.items[index].packing = _orderItem.packing;
        this.orderItem = this.items[index];
        this.items[index].userId = _orderItem.userId;
      } else {
        this.orderItem = _orderItem;
      }
      this.mode = 'U';
      // Save this order to the mongo db:
      this.editOrderValue(this.orderItem).subscribe((data) => {
        // if (this.mode === 'I') {
        this.orderItem.discountPrice = Math.round(
          this.orderItem.price * this.orderItem.quantity - this.orderItem.price * this.orderItem.quantity * 0.87 * (this.settingsData.discount / 100)
        );
        this.items = this.items.filter((_item) => _item.id !== _orderItem.id);
        _orderItem.discountPrice = this.orderItem.discountPrice;
        this.items.push(_orderItem);
        // }

        this.orderSubject.next(<OrderState>{loaded: true, items: this.items});

        window.scrollTo(0, 0);
      });
    } else {
      this.orderItem = _orderItem;
      this.mode = 'I';

      // Save this order to the mongo db:
      this.addOrderValue(this.orderItem).subscribe((data) => {
        if (this.mode === 'I') {
          this.orderItem.discountPrice = Math.round(
            this.orderItem.price * this.orderItem.quantity - this.orderItem.price * this.orderItem.quantity * 0.87 * (this.settingsData.discount / 100)
          );
          this.items.push(_orderItem);
        }

        this.orderSubject.next(<OrderState>{loaded: true, items: this.items});

        window.scrollTo(0, 0);
      });
    }
  }

  arrangeOrder(orderItemInfo: any, isFormSubmit: boolean) {
    if (isFormSubmit) {
      let orderDate = Utility.getTodayDate();
      const menuItemId = orderItemInfo.menuItemId;
      if (typeof orderItemInfo.date !== 'undefined' && typeof orderItemInfo.date.formatted !== 'undefined') {
        orderDate = orderItemInfo.date.formatted;
      } else if (orderItemInfo.isNew === '' && (orderItemInfo.date !== '') && typeof orderItemInfo.date !== 'undefined') {
        const date = new Date(orderItemInfo.date);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        orderDate = year + '-' + month + '-' + day;
      } else {
        orderDate = Utility.getTodayDate();
      }

      this.menuService.getOrderNamebyId(menuItemId).subscribe((item) => {
        this.orderItem = {
          id: orderItemInfo.id,
          menuItemId: orderItemInfo.menuItemId,
          quantity: orderItemInfo.quantity,
          note: orderItemInfo.note,
          date: orderDate,
          title: item.title,
          price: item.price,
          packing: orderItemInfo.packing,
          orderType: 2,
          userId: orderItemInfo.userId ? orderItemInfo.userId : this.loggedId,
          isNew: orderItemInfo.isNew ? orderItemInfo.isNew : 0
        };

        this.saveOrder(this.orderItem);
      });
    } else {
      this.orderItem = {
        id: uuid(),
        menuItemId: orderItemInfo.id,
        quantity: 1,
        note: '',
        date: Utility.getTodayDate(),
        title: orderItemInfo.title,
        price: orderItemInfo.price,
        packing: false,
        orderType: 1,
        userId: this.loggedId,
        isNew: 1
      };

      this.saveOrder(this.orderItem);
    }
  }

  removeQuickOrder(id: number): Observable<any> {
    return Observable.create((observer) => {
      this.deleteOrderItem(id, Query.deleteOrderItem).subscribe(
        (res) => {
          this.items = this.items.filter((_item) => _item.id !== id);
          this.orderSubject.next(<OrderState>{loaded: false, items: this.items});

          observer.next();
          this.onEnd();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }

  deleteOrdersByMenuId(id: number): Observable<any> {
    return Observable.create((observer) => {
      this.deleteOrdersByItemId(id, Query.deleteOrderItemByMenu).subscribe(
        (res) => {
          this.items = this.items.filter((_item) => _item.id !== id);
          this.orderSubject.next(<OrderState>{loaded: false, items: this.items});

          observer.next();
          observer.complete();
        },
        (err) => {
          observer.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/order.service.ts